export default function WindowSagging() {
  const checks = [
    "Le vantail frotte contre le dormant en bas ou sur le côté",
    "La fenêtre est dure à ouvrir et à fermer, elle grince",
    "On voit un espace inégal entre le vantail et le dormant",
    "La poignée ne s'aligne plus correctement avec la gâche",
    "Le joint ne compresse plus uniformément, laissant passer l'air",
    "Le vantail a l'air \u00ablourd\u00bb et tombe légèrement quand on l'ouvre",
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Signes d'usure
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Fenêtre qui s'{" "}
            <span className="font-serif italic">affaisse</span> ou frotte
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              Le premier signe d'un gond usé est une fenêtre qui s'affaisse progressivement. Le vantail descend de quelques millimètres, ce qui suffit à créer un frottement contre le seuil ou le dormant. Vous sentez une résistance dès les premiers centimètres d'ouverture, la manœuvre devient pénible, et au fil du temps vous finissez par éviter d'ouvrir la fenêtre. C'est un cercle vicieux : le frottement accélère l'usure des gonds et finit par endommager la crémone qui doit compenser le désalignement.
            </p>
            <p>
              Un autre signe fréquent est le grincement métallique à l'ouverture. Le roulement du gond est écrasé ou desséché, l'axe frotte directement sur la bague. Sans intervention, le gond peut finir par casser net, et le vantail se détache partiellement du dormant. Notre technicien diagnostique le type de gond (réglable ou fixe), mesure le désaxage, et remplace la pièce si nécessaire. Dans la plupart des cas, un remplacement de gond combiné à un réglage de hauteur suffit à rendre la fenêtre comme neuve.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Les signes qui indiquent un gond ou une paumelle usée
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}